import { getMapTileKey } from "./api";

/**
 * Raster basemap for the map widgets. CARTO's CDN serves these tiles; the key
 * (see `getMapTileKey` — the bundle's built-in production key unless the host
 * page overrides it) rides along as `?key=…` so the requests are attributed to
 * our account. Only the debug bar can make a request keyless.
 */
export const DEFAULT_TILE_URL_TEMPLATE =
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png";

export const TILE_ATTRIBUTION = "&copy; OpenStreetMap &copy; CARTO";

/**
 * Append the tile-server key as a `key` query parameter. Pure: an empty key
 * returns the template untouched, and an existing query string is extended
 * rather than clobbered. Leaflet's `{s}/{z}/{x}/{y}{r}` placeholders survive
 * because the key is URL-encoded (no braces can sneak in).
 */
export function withTileKey(template: string, key: string): string {
  const k = key.trim();
  if (!k) return template;
  const sep = template.includes("?") ? "&" : "?";
  return `${template}${sep}key=${encodeURIComponent(k)}`;
}

/** The tile URL template with the configured key (if any) applied. */
export function getTileUrlTemplate(): string {
  return withTileKey(DEFAULT_TILE_URL_TEMPLATE, getMapTileKey());
}
